import React, { useEffect, useState, useMemo } from 'react';
import './Home.scss';
import { Button, Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import { useHeaderMenu } from '../../contexts/login.context';
import { CartData } from "../../interfaces/CartData";
import { config } from "../../config";
import { useTranslation } from 'react-i18next';
import BrowserSupport from '../BrowserSupport/BrowserSupport';
//import Spinner from "../Spinner/Spinner";
import { useLocalization } from '../../contexts/LocalizationContext';
import { isGuestCheckoutAvailable } from './guestCheckoutAvailability';

interface PhysicalViewProps {
    cartData: CartData | null;
    loggedIn?: boolean;
}
const retry = (isDone: () => boolean, next: (isTimeout: boolean) => void) => {
    let current_trial = 0,
        max_retry = 50,
        is_timeout = false;
    var id = window.setInterval(
        function () {
            if (isDone()) {
                window.clearInterval(id);
                next(is_timeout);
            }
            if (current_trial++ > max_retry) {
                window.clearInterval(id);
                is_timeout = true;
                next(is_timeout);
            }
        },
        10
    );
}
const detectPrivateMode = (callback: (isPrivate: boolean) => void) => {
    var is_private;
    if (window.indexedDB && /Firefox|Edg/.test(window.navigator.userAgent)) {
        if (navigator.serviceWorker === undefined) {
            is_private = true;
        }
        var db;
        try {
            db = window.indexedDB.open('test');
        } catch (e) {
            is_private = true;
        }
        if (typeof is_private === 'undefined') {
            retry(
                function isDone() {
                    return db.readyState === 'done' ? true : false;
                },
                function next(is_timeout) {
                    if (!is_timeout) {
                        is_private = db.result ? false : true;
                    }
                }
            );
        }
    }
    retry(
        function isDone() {
            return typeof is_private !== 'undefined' ? true : false;
        },
        function next(is_timeout) {
            callback(is_private);
        }
    );
}
function Home({ cartData: cartProps, loggedIn }: PhysicalViewProps) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [cartData, setCartData] = useState<CartData | null>(cartProps);
    const { setLoginStatus, setItemsInCart } = useHeaderMenu();
    const [modalShow, setModalShow] = React.useState(false);
    const [isPrivateBrowsing, setisPrivateBrowsing] = React.useState(false);
    const [isFirefox, setIsFirefox] = useState(false);
    const { locale } = useLocalization();

    useEffect(() => {
        // Check for properties of the browser\
        const isFirefoxBrowser = window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        setIsFirefox(isFirefoxBrowser);
        detectPrivateMode((is_private => {
            setisPrivateBrowsing(is_private);
        }));
        // If the browser is Firefox and IndexedDB is not available, it may be in private mode

        if (loggedIn) {
            let userType = 'loggedIn';
            setLoginStatus(true);
            navigate(`/${locale}/software/cart/user/${userType}`);
            sessionStorage.setItem('customer', userType);
        } else {
            if (cartData) {
                // Navigate to another route
                setItemsInCart(cartData.totalItemsInCart);
            } else {
                if (cartProps && cartProps?.totalItemsInCart) {
                    setCartData(cartProps)
                } else {
                    window.location.href = config.bcOrdersUrl
                }
            }
        }
        let cartState = cartData?.cartItems?.cartItem;
        const items = cartState?.map((cartItem) => ({
            quantity: cartItem.quantity,
            price: {
                basePrice: parseFloat(String(cartItem?.pricing?.formattedListPrice ?? '').replace(/[^\d.]/g, '')) || 0, // Convert to number
                discount: 0, // Assuming no discount information is present
            },
            productInfo: {
                sku: `sku-${cartItem.product.id}`, // Generate SKU from product ID if no SKU exists
                prodID: cartItem.product.id.toString(),
                productName: cartItem.product.name,
            },
        }));
        //   const locale = window.location.pathname.split('/')[1]; // Extract 'en-us'
        const formattedLocale = locale?.replace('-', '_').toLowerCase().replace(/^[a-z]{2}/, match => match.toUpperCase());
        const cart = {
            customerID: "",
            orderID: cartData?.cartId,
            currencyCode: cartData?.pricing?.orderTotal?.currency,
            loginState: 'guest',
            storeLocale: formattedLocale,
            promoCode: "no",
            items: items
        }
        if (typeof window !== "undefined") {
            (window as any).CartOrder = cart;
        }
        console.log((window as any).CartOrder);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (isFirefox && isPrivateBrowsing) {
            setModalShow(true); // Show the modal
        }
    }, [isFirefox, isPrivateBrowsing])

    const ssoLoginURL = useMemo(() => {
        return `${config.bcSSOLoginUrl}${locale}/software/cart`
    }, [locale])

    const handleSubmit = (btnType: string) => {
        if (btnType) {
            navigate(`/${locale}/software/cart/user/${btnType}`);
            sessionStorage.setItem('customer', btnType);
        } else {
            // Navigate to another route
            navigate(`/${locale}/software/cart/`);
        }
    };
    const handleSSOCreateAccount = () => {
        window.location.href = ssoLoginURL;
    }
    return (<>
        {
            // loading ? (<Spinner />) : (

                <div className="userHome">
                    <Container>
                        <Row xs={'auto'} md={'auto'}>
                            <Col md={12}>
                                <h1 className='pageHeading' id="chooseCheckoutType">{t('CHECKOUT_TYPE')}</h1>
                            </Col>
                        </Row>
                    </Container>
                    <Container>
                        {cartData && (<Row xs={'auto'} md={'auto'} className='justfyCenter'>
                            <Col md={4}>
                            <Form id="dr_loginContainer" aria-labelledby="loginTitle" role="form">
                                    <Form.Group as="fieldset" id="dr_login">
                                        <h3 id="loginTitle">{t('CHECKOUT_TYPE_REGISTERED')}</h3>
                                        <p id="dr_loginInstructions" className="dr_loginInstructions">{t('SSO_SIGNIN_MESSAGE')}</p>


                                        <div id="dr_siteButtons" className="dr_loginButton">
                                            <Button variant="success" className='dr_button' onClick={() => handleSSOCreateAccount()}> {t('BTN_LOGIN')}</Button>
                                        </div>

                                </Form.Group> </Form>  


                            </Col>

                            <Col md={4}>
                                <div id="dr_checkoutoutTypeContainer">
                                    <Form.Group as="fieldset" id="dr_checkoutType" aria-labelledby="newCustomerTitle" role="group">
                                        <h3 id="newCustomerTitle">{t('NEW_CUSTOMER_TITLE')}</h3>
                                        <p>{t('NEW_CUSTOMER_DESC')}</p>
                                        {/* <Form.Control type="submit" className="dr_button" id="btnCreateAccount" name="create_account" value="" /> */}

                                            <Button
                                                variant="success"
                                                className='dr_button'
                                                onClick={() => handleSSOCreateAccount()}
                                                id='btnCreateAccount'
                                                aria-label={t('SSO_CREATE_ACCOUNT')}
                                                aria-labelledby="newCustomerTitle"
                                                role="button"
                                            >
                                                {t('SSO_CREATE_ACCOUNT')}
                                            </Button>

                                        {isGuestCheckoutAvailable(cartData.category) && (
                                            <>
                                                <p className='orText'>{t('OR_TEXT')}</p>
                                                <span id="guestCustomerTitle" className="sr-only">{t('CHECKOUT_GUEST_BTN')}</span>
                                                <Button
                                                    variant="success"
                                                    className='dr_button'
                                                    onClick={(e) => handleSubmit('guest')}
                                                    id="btnCheckoutAsGuest"
                                                    aria-label={t('CHECKOUT_GUEST_BTN')}
                                                    aria-labelledby="guestCustomerTitle"
                                                    role="button"
                                                >
                                                    {t('CHECKOUT_GUEST_BTN')}
                                                </Button>
                                            </>
                                        )}
                                    </Form.Group>
                                </div>
                            </Col>
                        </Row>)}
                    </Container>
                    {isFirefox && isPrivateBrowsing && <BrowserSupport
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                    />}
                </div>
            // )
        }

    </>);
}
export default Home;